export default {
  "nav.home": "Accueil",
  "nav.guide": "Guide d'achat",
  "nav.browse": "Parcourir les catégories",
  "brand.tagline": "Ressource USFans Spreadsheet",
  "brand.subtag": "Ressource indépendante",

  "cta.spreadsheet": "USFans Spreadsheet",
  "cta.buyNow": "Acheter maintenant",
  "cta.explore": "Explorer le Spreadsheet USFans",
  "cta.browse": "Parcourir les catégories",
  "cta.main": "Aller au site principal",

  "dropdown.label": "Aller à une catégorie",
  "dropdown.placeholder": "Choisir une catégorie…",

  "category.shoes": "Chaussures",
  "category.hoodies": "Hoodies/Sweats",
  "category.tshirts": "T-Shirts",
  "category.jackets": "Vestes",
  "category.pants": "Pantalons/Shorts",
  "category.headwear": "Couvre-chefs",
  "category.sets": "Ensembles",
  "category.underwear": "Sous-vêtements/Caleçons",
  "category.jersey": "Maillots",
  "category.accessories": "Accessoires",
  "category.bags": "Sacs",
  "category.belts": "Ceintures",
  "category.perfumes": "Parfums",
  "category.other": "Autres articles",

  "categoryDesc.shoes": "Baskets, chaussures casual et sport.",
  "categoryDesc.hoodies": "Pulls, zippés et couches chaudes.",
  "categoryDesc.tshirts": "Hauts à manches courtes et longues.",
  "categoryDesc.jackets": "Vêtements d'extérieur pour chaque saison.",
  "categoryDesc.pants": "Jeans, chinos et shorts.",
  "categoryDesc.headwear": "Casquettes, chapeaux et bonnets.",
  "categoryDesc.sets": "Tenues coordonnées assorties.",
  "categoryDesc.underwear": "Sous-vêtements et essentiels.",
  "categoryDesc.jersey": "Maillots de sport et d'équipe.",
  "categoryDesc.accessories": "Montres et petits accessoires.",
  "categoryDesc.bags": "Sacs à dos, sacs à main et fourre-tout.",
  "categoryDesc.belts": "Ceintures en cuir et casual.",
  "categoryDesc.perfumes": "Parfums pour hommes et femmes.",
  "categoryDesc.other": "Divers et nouveautés.",

  "footer.about": "usfanslink.lol est une ressource d'information indépendante sur le Spreadsheet USFans. Nous ne sommes pas affiliés à USFans.",
  "footer.disclaimer": "Avertissement",
  "footer.disclaimerText": "Ce site est une ressource d'information indépendante et n'est pas nécessairement affilié à USFans.",
  "footer.quickLinks": "Liens rapides",
  "footer.rights": "Tous droits réservés.",
};